import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ElevenLabsModelType } from '@shared/index';
import { firstValueFrom } from 'rxjs';
import { RouteShareService } from './route-share.service';

export type voice = {
  voiceId: string,
  name: string,
  description?: string,
  previewUrl: string,
  verifiedLanguages: {
    language: string,
    modelId: string,
    accent: string,
    locale: string,
    previewUrl: string
  }[]
  sharing?: {
    status: string
  }
  fineTuning: {
    state: {
      eleven_flash_v2_5?: string,
      eleven_v2_5_flash?: string
      eleven_multilingual_v2?: string
    },
  },
  highQualityBaseModelIds: string[],
  labels: {
    accent: string,
    description?: string,
    descriptive?: string,
    age: string,
    gender: string,
    use_case: string
  }
}

@Injectable({
  providedIn: 'root'
})
export class VoiceService {
  public voices: voice[] = [];

  constructor(
    private http: HttpClient,
    private rss: RouteShareService
  ) { }

  public async getVoices() {
    this.voices = (await firstValueFrom(this.http.get<voice[]>("/api/toolbox/audio/voices/" + this.rss.botConfig._id)));
  }

  public getVoicesByModel(model: ElevenLabsModelType) {
    return this.voices.filter((v) => v.highQualityBaseModelIds.includes(model));
  }

  public getLangByVoiceAndModel(voice: string, lang: string) {
    return this.voices.find((v) => v.voiceId === voice)?.verifiedLanguages.find((l) => l.modelId === this.rss.botConfig.voiceConfig.model && l.language === lang);
  }

  public getDemoText(id: string) {
    return this.voices.find((v) => v.voiceId === id)?.previewUrl ?? '';
  }
}
